import { DataTypes } from "../../../Common/Data/DataTypes";
import { BaseJSONXMLElement } from "./BaseJSONXMLElement";

export class JSONXMLStringElement extends BaseJSONXMLElement {
    readonly __type: string = "jsonstring";
    readonly name: string = "String Value";
    readonly ordinal: number = 0;
    readonly outputType: DataTypes = DataTypes.STRING;
    readonly styleElement: boolean = false;
}
